declare global {
  interface Window {
    _env_: any;
  }
}

export const environment = {
  // helmet meta data
  metaTitle: window._env_.REACT_APP_META_TITLE,
  metaDescription: window._env_.REACT_APP_META_DESC,
  metaUrl: window._env_.REACT_APP_META_URL,
  metaImg: window._env_.REACT_APP_META_IMG,
  metaImgAlt: window._env_.REACT_APP_META_IMG_ALT,
  //
  apiUrl: window._env_.REACT_APP_API_URL,
  clientId: window._env_.REACT_APP_IS_CLIENT,
  authority: window._env_.REACT_APP_IS_URL,
  useLocalTranslations: window._env_.REACT_APP_USE_LOCAL_TRANSLATIONS,
  scope: window._env_.REACT_APP_IS_SCOPE,
  silentLoginTimeout: 20000, // ms
  defaultCoords: {
    lat: 50.07151,
    lng: 14.43316,
  },
  apiKey: window._env_.REACT_APP_GMAPS_KEY,
  defaultLocale: 'en-GB',
  appName: 'PressView',
  imageExtensions: ['.jpeg', '.jpg', '.gif', '.png'],
  maxImageFileSize: 1024 * 1024 * 5, //5 MB,
  sessionCookieDomain: window._env_.REACT_APP_SESSION_COOKIE_DOMAIN,
  sessionCookieSecure: Boolean(window._env_.REACT_APP_SESSION_COOKIE_SECURE),
  sessionCookieIdleTimeout: Number(window._env_.REACT_APP_SESSION_COOKIE_IDLE_TIMEOUT),
  streetviewMarkerLength: 60,
  minDefaultAreaDimensionInMetres: 400, //Approximate
  version: window._env_.REACT_APP_VERSION,
  //
  zoomForClusters: 14,
  zoomLevelOnSingleSite: 18,
  minMapZoom: 3,

  clarityId: window._env_.REACT_APP_CLARITY_ID,
};
